export class DailyRewardSaveModule {
    constructor(userId, _provider) {
        this._provider = _provider;
        this.version = 1;
        this._data = null;
        this._key = `saves/${userId}/modules/daily-reward`;
    }
    getKey() {
        return this._key;
    }
    save(data) {
        this._data = data;
        void this._provider.set(this._key, data);
    }
    load() {
        return this._data;
    }
    migrate(_old, _fromVersion) {
        return { lastClaimDate: null, dayCounter: 1, streakCount: 0, version: 1 };
    }
}
